"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _Paper = _interopRequireDefault(require("@mui/material/Paper"));

var _List = _interopRequireDefault(require("@mui/material/List"));

var _ListSubheader = _interopRequireDefault(require("@mui/material/ListSubheader"));

var _Spinner = _interopRequireDefault(require("@developers/ui/Spinner"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ShippingTable = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(ShippingTable, _Component);

  var _super = _createSuper(ShippingTable);

  function ShippingTable() {
    (0, _classCallCheck2["default"])(this, ShippingTable);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(ShippingTable, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          count = _this$props.count,
          loading = _this$props.loading;

      if (count <= 0) {
        return /*#__PURE__*/_react["default"].createElement("span", null);
      }

      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Paper["default"], {
        style: {
          position: 'relative',
          marginBottom: '15px'
        }
      }, /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
        show: loading
      }), /*#__PURE__*/_react["default"].createElement(_List["default"], {
        subheader: /*#__PURE__*/_react["default"].createElement(_ListSubheader["default"], null, "Shipping")
      }, this.props.children)));
    }
  }]);
  return ShippingTable;
}(_react.Component);

exports["default"] = ShippingTable;